/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AbstractResponsiveComponent from './AbstractResponsiveComponent';

class BannerOverlineContent extends Component {
	view() {
		return <h4 className={this.attrs.className}>{m.trust(this.attrs.deviceData)}</h4>;
	}
}

export default class BannerOverline extends AbstractResponsiveComponent {
	get data() {
		return this.attrs.banner.content()?.overline;
	}

	getClassName() {
		return `${super.className} BannerOverline`;
	}

	get content() {
		return BannerOverlineContent;
	}
}
